import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';

// ABSOLUTE FIRST LOG - If you don't see this, JS isn't loading at all
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Registro mejorado de Service Worker con auto-actualización
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/service-worker.js')
            .then((registration) => {
                // Verificar actualizaciones cada 60 segundos
                setInterval(() => {
                    registration.update();
                }, 60000);

                // Detectar cuando hay un nuevo service worker esperando
                registration.addEventListener('updatefound', () => {
                    const newWorker = registration.installing;
                    newWorker.addEventListener('statechange', () => {
                        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                            // Recargar la página para usar la nueva versión
                            window.location.reload();
                        }
                    });
                });
            })
            .catch((error) => {
            });

        // Recargar cuando el service worker tome control
        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (!refreshing) {
                refreshing = true;
                window.location.reload();
            }
        });
    });
}
